import { render, staticRenderFns } from "./TrustPilotReviews.vue?vue&type=template&id=2c82eb1d&"
import script from "./TrustPilotReviews.vue?vue&type=script&lang=ts&"
export * from "./TrustPilotReviews.vue?vue&type=script&lang=ts&"
import style0 from "./TrustPilotReviews.vue?vue&type=style&index=0&id=2c82eb1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports